const groupPrefix = createApiRoute(ApiModule.SUPPLIER, ApiAuthorization.EMPLOYEE)

export const apiSuppliersPurchaseConditions = {
	fetchSupplierLogistics: async (supplierId: number): Promise<IApiResponseModel<IPurchaseConditionsModel>> => {
		const { data, meta } = await apiCommon<IPurchaseConditions>(`${groupPrefix}/${supplierId}/logistics`, {
			method: 'GET',
		})
		return { data: PurchaseConditions(data), meta }
	},

	saveSupplierLogistics: async (supplierId: number, data: IPurchaseConditionsModel) => {
		const body = PurchaseConditionsToJson(data)
		await apiCommon(`${groupPrefix}/${supplierId}/logistics`, {
			method: 'POST',
			body,
		})
	},
}
